export default "__VITE_ASSET__1988c564__"